export const isCurrencyValueZero = (totalAmount: string): boolean => {
  const numericValue = parseFloat(totalAmount.replace(/[^0-9.-]+/g, ''));
  return numericValue === 0;
};
